import { TextInput } from '@core/components/Inputs';
import { SelectSimple } from '@core/components/Select';
import { Grid } from '@material-ui/core';
import { useFormikContext } from 'formik';
import React from 'react';
import VendedorDadosGeraisPessoaFisica from './VendedorDadosGeraisPessoaFisica';
import VendedorDadosGeraisPessoaJuridica from './VendedorDadosGeraisPessoaJuridica';

const TabDadosGeraisVendedor = ({ onChangeTipoPessoa, fetchPapel }) => {
  const formik = useFormikContext();

  const handleChangeTipoPessoa = (event) => {
    formik.handleChange(event);
    onChangeTipoPessoa(event.target.value);
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <TextInput
          id="pessoa.nome"
          name="pessoa.nome"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.pessoa.nome}
          error={formik.errors?.pessoa?.nome}
          touched={formik.touched?.pessoa?.nome}
          required
          fullWidth
          autoFocus
          variant="outlined"
          label="Nome"
          maxLength={100}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
        <SelectSimple
          defaultValue="FISICA"
          label="Tipo de pessoa"
          id="pessoa.tipoPessoa"
          onChange={handleChangeTipoPessoa}
          value={formik.values.pessoa.tipoPessoa}
          options={[
            { title: 'Pessoa Jurídica', id: 'JURIDICA' },
            { title: 'Pessoa Física', id: 'FISICA' },
          ]}
          disabled={formik.values.possuiVinculo}
        />
      </Grid>

      {formik.values.pessoa.tipoPessoa === 'FISICA' ? (
        <VendedorDadosGeraisPessoaFisica
          id="pessoa.pessoaFisica"
          name="pessoa.pessoaFisica"
          values={{
            pessoaFisica: formik.values.pessoa?.pessoaFisica,
            comissao: formik.values.comissao,
            inscricaoMunicipal: formik.values.pessoa?.inscricaoMunicipal,
          }}
          onBlur={formik.handleBlur}
          onChange={formik.handleChange}
          touched={formik.touched?.pessoa}
          errors={formik.errors?.pessoa}
          fetchPapel={fetchPapel}
          possuiVinculo={formik.values.possuiVinculo}
        />
      ) : (
        <>
          <VendedorDadosGeraisPessoaJuridica
            id="pessoa.pessoaJuridica"
            name="pessoa.pessoaJuridica"
            values={{
              pessoaJuridica: formik.values.pessoa?.pessoaJuridica,
              comissao: formik.values.comissao,
              inscricaoMunicipal: formik.values.pessoa?.inscricaoMunicipal,
            }}
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            touched={formik.touched?.pessoa}
            errors={formik.errors?.pessoa}
            fetchPapel={fetchPapel}
            possuiVinculo={formik.values.possuiVinculo}
          />
        </>
      )}
    </Grid>
  );
};

export default TabDadosGeraisVendedor;
